// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp, FirebaseApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence, Firestore } from "firebase/firestore";
import { getAuth, Auth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAuD2TH0cxSel0AhtTneBB_YfpMir1K3dY",
  authDomain: "e-01-20453857-41c1c.firebaseapp.com",
  projectId: "e-01-20453857-41c1c",
  storageBucket: "e-01-20453857-41c1c.firebasestorage.app",
  messagingSenderId: "186518437187",
  appId: "1:186518437187:web:6d7715eda69f20d64a43f6"
};

// Initialize Firebase
const app: FirebaseApp = !getApps().length ? initializeApp(firebaseConfig) : getApp();

const db: Firestore = getFirestore(app);
const auth: Auth = getAuth(app);
const storage = getStorage(app);

// Enable offline persistence only in the browser
if (typeof window !== 'undefined') {
  try {
    enableIndexedDbPersistence(db)
      .then(() => console.log("Firestore offline persistence enabled."))
      .catch((err) => {
        if (err.code === 'failed-precondition') {
          console.warn('Firestore persistence failed: Multiple tabs open?');
        } else if (err.code !== 'unimplemented') {
          console.error('Firestore persistence error:', err);
        }
      });
  } catch (e) {
    console.error("An error occurred while enabling persistence.", e);
  }
}

export { app, db, auth, storage };
